/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReorderVendorCheckItemsDto } from '../../models/reorder-vendor-check-items-dto';

export interface AsControllerReorderChecklistItems$Params {
  clientWorkspaceId: string;
  symptomId: string;
      body: ReorderVendorCheckItemsDto
}

export function asControllerReorderChecklistItems(http: HttpClient, rootUrl: string, params: AsControllerReorderChecklistItems$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, asControllerReorderChecklistItems.PATH, 'patch');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('symptomId', params.symptomId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

asControllerReorderChecklistItems.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/symptoms/{symptomId}/check-items/reorder';
